<template>
    <div class="">
        <div class="d-flex align-items-center justify-content-between">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item"><router-link to="/dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">{{ tab === 'staff' ? 'Non Marketing Attendance' : 'Marketing Attendance' }}</li>
                </ol>
                <label class="form-label"> <h4>{{ tab === 'staff' ? 'Non Marketing Attendance' : 'Marketing Attendance' }}</h4></label>
            </div>
            <div class="d-flex">
                 <button class="btn d-flex align-item-center btn-success" @click="downloadExcel"><i class="ri-download-line me-1"></i>{{ tab === 'staff' ? 'Download Non Marketing Attendance' : 'Download Marketing Attendance' }}</button>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-md-6">
                <strong class="main-title mb-3">Attendance</strong>
            </div>
            <div class="col-md-6">
                <button style="float:right" class="btn d-flex align-item-center btn-success btn-sm" @click="downloadExcel">Download Attendance</button>
            </div>
        </div> -->
        <div class="row">
            <div class="col-md-6">
                <div class="card br-16 card-shadow">
                    <div class="card-body">
                        <ul class="nav nav-tabs mb-3">
                            <li class="nav-item">
                                <a class="nav-link" :class="{ active: tab === 'marketing' }" href="javascript:void(0)" @click="setTab('marketing')">Marketing Attendance</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{ active: tab === 'staff' }" href="javascript:void(0)" @click="setTab('staff')">Non Marketing Attendance</a>
                            </li>
                        </ul>
                        <div class="input-group ">
                            <Search
                            :key="searchKey"
                            class="mb-3 me-2"
                            :class="{ 'is-invalid': errors?.user_id }"
                            :customClass="{ 'is-invalid': errors?.user_id }"
                            :initialize="meta.user_id"
                            id="user_id"
                            label="name"
                            placeholder="Select User"
                            :data=" users"
                            @input="user => { meta.user_id = user; index(); }"
                        >
                        </Search>
                            <flatPickr class="form-control mb-3" placeholder="Select Date Range"
                                :class="{ 'is-invalid': errors?.date_time }" v-model="meta.date_time"
                                :config="config" @onChange="getSelectedDates" style="width: 200px;">
                            </flatPickr>
                            <button class="btn btn-primary mb-3" type="button" id="button-addon2" @click="index()">Search</button>

                        </div>
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th>
                                            Username
                                            <!-- <div class="row">
                                                <div class="col-md-6">
                                                    <input type="datetime-local" class="form-control" name="from_date_time" />
                                                </div>
                                                <div class="col-md-6">
                                                    <button type="button" class="btn btn-primary">Search</button>
                                                </div>
                                            </div> -->

                                        </th>
                                        <th>
                                            Session Started
                                        </th>
                                        <th>
                                            Session Ended
                                        </th>
                                        <th class="text-center">View</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="usersAttendance?.length == 0">
                                        <td colspan="4" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="(userAttendance, key) in usersAttendance" :key="key" @click="getLocationValues(userAttendance?.user_id)" style="cursor: pointer;">
                                        <td style="font-size: 16px; padding: 10px;">
                                            <span>{{  key + 1 }}</span>. {{ userAttendance?.User?.name }}
                                        </td>
                                        <td>
                                            <span>{{ getSessionStartTime(userAttendance?.user_id) }}</span>
                                        </td>
                                        <td>
                                            <span>{{ getSessionEndTime(userAttendance?.user_id) }}</span>
                                        </td>
                                        <td class="text-center" @click.stop>
                                            <a v-if="showActivityView(userAttendance)" href="javascript:void(0)" class="text-success" data-bs-toggle="modal" data-bs-target="#staffActivities" @click.prevent="viewActivities(userAttendance)">
                                                <i class="ri-eye-line fs-18 lh-1"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div v-if="locations.length" style="width: 100%; height: 500px">
                    <GMapMap :center="center" :zoom="12" style="width: 100%; height: 500px">
                        <GMapMarker
                            v-for="(location, index) in locations"
                            :key="index"
                            :position="{ lat: location.lat, lng: location.lng }"
                        />
                        <GMapPolyline
                            :path="locations"
                            :options="{ strokeColor: '#FF0000', strokeOpacity: 1.0, strokeWeight: 2 }"
                        />
                    </GMapMap>
                </div>
                <div v-else-if="selectedUserId" class="card br-16 card-shadow">
                    <div class="card-body text-center text-muted py-5">
                        No location data available for this user in the selected date range.
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="staffActivities" tabindex="-1" aria-labelledby="staffActivitiesLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="staffActivitiesLabel">{{ modalUserName }} Activities</h5>
                        <div class="d-flex align-items-center gap-2">
                            <button type="button" class="btn btn-success btn-sm" @click="downloadModalExcel">
                                <i class="ri-download-line me-1"></i>Download
                            </button>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                    <div class="modal-body d-flex flex-column" style="height: 70vh; overflow-y: auto;">
                        <div class="d-flex align-items-center gap-2 mb-3">
                            <input class="form-control" type="text" placeholder="Search activity, status, or note" v-model="modalSearch" @input="onModalSearch" style="max-width: 280px;" />
                            <button type="button" class="btn btn-outline-primary" @click="showModalFilter = !showModalFilter">
                                <i class="ri-filter-3-line"></i>
                            </button>
                            <template v-if="showModalFilter">
                                <input class="form-control" type="date" v-model="modalFromDate" style="max-width: 180px;" />
                                <input class="form-control" type="date" v-model="modalToDate" style="max-width: 180px;" />
                                <button type="button" class="btn btn-primary" @click="searchModalActivities">Submit</button>
                            </template>
                        </div>
                        <div class="table-responsive flex-grow-1">
                            <table class="table table-sm table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th>Sr. No</th>
                                        <th>Session Started</th>
                                        <th>Activity</th>
                                        <th>Status</th>
                                        <th>Reminder</th>
                                        <th>Activity Started</th>
                                        <th>Activity Ended</th>
                                        <th>Total Hours</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="!modalRows.length">
                                        <td colspan="8" class="text-center text-muted">No records found</td>
                                    </tr>
                                    <tr v-for="(row, rowIndex) in modalRows" :key="rowIndex">
                                        <td>{{ (modalMeta.from || 1) + rowIndex }}</td>
                                        <td style="min-width: 180px; white-space: normal;">
                                            <div style="font-weight: 600;">{{ formatSessionTime(row.session.from_date_time) || '-' }}</div>
                                            <div class="text-muted">{{ row.session.note || '-' }}</div>
                                        </td>
                                        <td style="white-space: normal;">{{ row.activity?.activity_name || '-' }}</td>
                                        <td class="text-capitalize">{{ row.activity?.status || '-' }}</td>
                                        <td>{{ row.activity ? (formatReminder(row.activity.reminder) || '-') : '-' }}</td>
                                        <td>{{ activityStarted(row.activity) || '-' }}</td>
                                        <td>{{ activityEnded(row.activity) || '-' }}</td>
                                        <td>{{ activityTotalHours(row.activity) || '-' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="mt-auto pt-3" v-if="modalMeta.total">
                            <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                <span>Showing {{ modalMeta.from }} to {{ modalMeta.to }} of {{ modalMeta.total }} entries</span>
                                <Pagination :maxPage="modalMeta.lastPage" :totalPages="modalMeta.lastPage" :currentPage="modalPage" @pagechanged="onModalPageChange" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axios from 'axios';
import Search from "@/components/Search.vue";
import moment from 'moment-timezone';
    export default {
        components: {
            Pagination,
            flatPickr,
            Search
        },
        data() {
            return {
                meta: {
                    date_time: "",
                    user_id: "",
                    from_date_time: moment().format("DD-MM-YYYY"),
                    to_date_time: moment().add(1, 'days').format("DD-MM-YYYY"),
                },
                usersAttendance: [],
                usersAttendanceDateTime: [],
                usersAttendanceLocation: [],
                locations: [],
                errors: [],
                users:[],
                allUsers: [],
                tab: "marketing",
                activities: [],
                staffSessions: [],
                searchKey: 0,
                modalUserName: "",
                modalActivities: [],
                modalSessions: [],
                modalSearch: "",
                modalPage: 1,
                modalPerPage: 10,
                modalRows: [],
                modalMeta: { total: 0, lastPage: 1, from: 0, to: 0 },
                modalSearchTimer: null,
                modalUserId: "",
                showModalFilter: false,
                modalFromDate: "",
                modalToDate: "",
                selectedUserId: null,
                center: { lat: 12.9716, lng: 77.5946 },
                map:'',
                config: {
                    mode:'range',
                    defaultDate: [moment().format("DD-MM-YYYY"), moment().add(1, 'days').format("DD-MM-YYYY")],
                    dateFormat: 'd-m-Y',
                }

            };
        },
    mounted() {
        this.getUsers();
			this.index();
        },
        methods: {
        getUsers() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "users/getUsers" })
                    .then((response) => {
                        loader.hide();
                        vm.allUsers = response.data.data || [];
                        vm.applyUserFilter();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response?.data?.errors;
                        vm.$store.dispatch("error", error.response?.data?.message || "Request failed");
                    });
            },

            success(position) {
                console.log(position)
            },
            error(error) {
                alert(error)
            },
            getSelectedDates(dates){
				let vm = this;
				vm.meta.from_date_time = moment(dates[0]).format("DD-MM-YYYY")
				vm.meta.to_date_time = moment(dates[1]).format("DD-MM-YYYY")
			},
            formatDateForApi(date_time, isEnd = false) {
                if (!date_time) {
                    return date_time;
                }

                const parsed = moment(date_time, [
                    "DD-MM-YYYY HH:mm:ss",
                    "DD-MM-YYYY",
                    "YYYY-MM-DD HH:mm:ss",
                    "YYYY-MM-DD",
                ], true);

                if (!parsed.isValid()) {
                    return date_time;
                }

                return (isEnd ? parsed.endOf("day") : parsed.startOf("day")).format("YYYY-MM-DD HH:mm:ss");
            },
            buildAttendancePayload(user_id = this.meta.user_id) {
                return {
                    from_date_time: this.formatDateForApi(this.meta.from_date_time, false),
                    to_date_time: this.formatDateForApi(this.meta.to_date_time, true),
                    user_id: user_id || "",
                };
            },
            applyUserFilter() {
                const isStaff = this.tab === "staff";
                this.users = (this.allUsers || []).filter((user) => {
                    return isStaff
                        ? user.attendance_type === "non marketing"
                        : user.attendance_type !== "non marketing";
                });
            },
            setTab(tab) {
                if (this.tab === tab) {
                    return;
                }
                this.tab = tab;
                this.meta.user_id = "";
                this.locations = [];
                this.activities = [];
                this.staffSessions = [];
                this.modalActivities = [];
                this.modalSessions = [];
                this.selectedUserId = null;
                this.usersAttendance = [];
                this.applyUserFilter();
                this.index();
                this.$nextTick(() => {
                    this.searchKey += 1;
                });
            },
            onModalPageChange(page) {
                this.modalPage = page;
                this.fetchModalActivities();
            },
            onModalSearch() {
                clearTimeout(this.modalSearchTimer);
                this.modalSearchTimer = setTimeout(() => {
                    this.modalPage = 1;
                    this.fetchModalActivities();
                }, 500);
            },
            fetchModalActivities(perPage) {
                let vm = this;
                const payload = {
                    user_id: vm.modalUserId,
                    from_date_time: vm.formatDateForApi(vm.modalFromDate, false),
                    to_date_time: vm.formatDateForApi(vm.modalToDate, true),
                    search: vm.modalSearch || "",
                    page: perPage ? 1 : vm.modalPage,
                    per_page: perPage || vm.modalPerPage,
                };
                const uri = vm.tab === "staff"
                    ? "staffAttendance/paginateModalActivities"
                    : "marketingActivity/paginateModalActivities";
                return vm.$store.dispatch("post", { uri: uri, data: payload })
                    .then(function (response) {
                        const body = response.data.data || {};
                        const rows = body.data || [];
                        if (!perPage) {
                            vm.modalRows = rows;
                            vm.modalMeta = {
                                total: body.meta?.total || 0,
                                lastPage: body.meta?.lastPage || 1,
                                from: body.meta?.from || 0,
                                to: body.meta?.to || 0,
                            };
                        }
                        return rows;
                    })
                    .catch(function (error) {
                        vm.errors = error.response?.data?.errors;
                        vm.$store.dispatch("error", error.response?.data?.message || "Request failed");
                        return [];
                    });
            },
            formatReminder(reminder) {
                if (!reminder) {
                    return "";
                }
                const parsed = moment(reminder);
                return parsed.isValid() ? parsed.format("DD-MM-YYYY hh:mm:ss A") : reminder;
            },
            index() {
                let vm = this;
                const payload = vm.buildAttendancePayload();
                const uri = vm.tab === "staff" ? "staffAttendance/staffAttendanceUsers" : "attendance/attendanceUsers";
                vm.$store.dispatch("post", { uri: uri, data: payload })
                .then(function (response) {
                    vm.usersAttendanceDateTime = response.data.data?.attendanceLogInTimes || [];
                    vm.usersAttendance = response.data.data?.attendanceStatus || [];
                    if (vm.usersAttendance.length > 0) {
                        vm.getLocationValues(vm.usersAttendance[0].user_id);
                    } else {
                        vm.locations = [];
                        vm.selectedUserId = null;
                    }
                })
                .catch(function (error) {
                    vm.errors = error.response?.data?.errors;
                    vm.$store.dispatch("error", error.response?.data?.message || "Request failed");
                });
            },
            activityStarted(activity) {
                if (!activity?.created_at) {
                    return "";
                }
                return this.formatSessionTime(activity.created_at);
            },
            activityEnded(activity) {
                if (!activity || String(activity.status || "").toLowerCase() !== "completed" || !activity.updated_at) {
                    return "";
                }
                return this.formatSessionTime(activity.updated_at);
            },
            activityTotalHours(activity) {
                if (!activity || String(activity.status || "").toLowerCase() !== "completed" || !activity.created_at || !activity.updated_at) {
                    return "";
                }
                const start = moment(activity.created_at);
                const end = moment(activity.updated_at);
                if (!start.isValid() || !end.isValid() || !end.isAfter(start)) {
                    return "";
                }
                const totalMinutes = end.diff(start, "minutes");
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;
                if (hours > 0 && minutes > 0) {
                    return `${hours}h ${minutes}m`;
                }
                if (hours > 0) {
                    return `${hours}h`;
                }
                return `${minutes}m`;
            },
            formatSessionTime(date_time) {
                if (!date_time) {
                    return "";
                }
                const parsed = moment(date_time);
                return parsed.isValid() ? parsed.format("DD-MM-YYYY hh:mm:ss A") : "";
            },
            sessionActivities(session) {
                return (this.modalActivities || []).filter((activity) => activity.staff_attendance_id == session.staff_attendance_id);
            },
            showActivityView(userAttendance) {
                if (this.tab === "staff") {
                    return true;
                }
                return !!userAttendance?.has_activity;
            },
            viewActivities(userAttendance) {
                let vm = this;
                vm.modalUserName = userAttendance?.User?.name || "";
                vm.modalUserId = userAttendance?.user_id || "";
                vm.modalSearch = "";
                vm.modalPage = 1;
                vm.showModalFilter = false;
                vm.modalFromDate = moment(vm.meta.from_date_time, "DD-MM-YYYY").format("YYYY-MM-DD");
                vm.modalToDate = moment(vm.meta.to_date_time, "DD-MM-YYYY").format("YYYY-MM-DD");
                vm.modalRows = [];
                vm.modalMeta = { total: 0, lastPage: 1, from: 0, to: 0 };
                vm.fetchModalActivities();
            },
            searchModalActivities() {
                if (!this.modalFromDate || !this.modalToDate) {
                    this.$store.dispatch("error", "Select from date and to date");
                    return;
                }
                this.modalPage = 1;
                this.fetchModalActivities();
            },
            getLocationValues(user_id){
                let vm = this;
                let loader = vm.$loading.show();
                vm.selectedUserId = user_id;
                vm.activities = [];
                vm.staffSessions = [];
                if (vm.tab === "staff") {
                    const match = (vm.usersAttendanceDateTime || []).find((item) => item.user_id == user_id);
                    vm.staffSessions = match?.attendance_logins || [];
                }
                const payload = vm.buildAttendancePayload(user_id);
                const uri = vm.tab === "staff" ? "staffAttendance/getStaffAttendanceMap" : "attendancesLocation/getAttendancesLocations";
                vm.$store.dispatch("post", { uri: uri, data: payload })
                .then(function (response) {
                    loader.hide();
                    const responseData = response.data.data;
                    vm.usersAttendanceLocation = vm.tab === "staff"
                        ? (responseData?.locations || [])
                        : (responseData || []);
                    const mappedLocations = vm.usersAttendanceLocation
                        .map(function(location) {
                            return {
                                lat: parseFloat(location.latitude),
                                lng: parseFloat(location.longitude),
                            };
                        })
                        .filter((location) => Number.isFinite(location.lat) && Number.isFinite(location.lng));

                    vm.locations = mappedLocations;
                    if (mappedLocations.length > 0) {
                        vm.center = { ...mappedLocations[0] };
                    }
                })
                .catch(function (error) {
                    loader.hide();
                    console.log('error:-----', error);
                    vm.errors = error.response?.data?.errors;
                    vm.$store.dispatch("error", error.response?.data?.message || "Request failed");
                });
            },

            getSessionStartTime(user_id){
                let vm = this;
                let result = vm.usersAttendanceDateTime?.filter(function(ele) {
                    return ele.user_id == user_id;
                })
                let login_date = result[0]?.attendance_logins[0]?.from_date_time;
                return moment(login_date).format("DD-MM-YYYY hh:mm:ss A");
            },

            getSessionEndTime(user_id){
                let vm = this;
                let result = vm.usersAttendanceDateTime?.filter(function(ele) {
                    return ele.user_id == user_id;
                })
                let logout_date;
                if(result[0]?.attendance_logins?.length > 1)
                {
                    logout_date = result[0]?.attendance_logins[result[0]?.attendance_logins?.length-1].to_date_time
                }
                else{
                    logout_date = result[0]?.attendance_logins[0].to_date_time
                }
                if(logout_date){
                    return moment(logout_date).format("DD-MM-YYYY hh:mm:ss A")
                }
                else{
                    return ''
                }

            },
            async downloadModalExcel() {
                try {
                    const sourceRows = await this.fetchModalActivities(10000);
                    const rows = (sourceRows || []).map((row, index) => ({
                        sr_no: index + 1,
                        session_started: this.formatSessionTime(row.session?.from_date_time) || "",
                        note: row.session?.note || row.activity?.note || "",
                        activity: row.activity?.activity_name || "",
                        status: row.activity?.status || "",
                        reminder: row.activity ? (this.formatReminder(row.activity.reminder) || "") : "",
                        activity_started: this.activityStarted(row.activity) || "",
                        activity_ended: this.activityEnded(row.activity) || "",
                        total_hours: this.activityTotalHours(row.activity) || "",
                    }));
                    const downloadUri = this.tab === "staff"
                        ? "staffAttendance/excelDownloadUserActivities"
                        : "marketingActivity/excelDownloadUserActivities";
                    const response = await axios({
                        url: this.$store.getters.apiUrl + "api/" + downloadUri,
                        method: "POST",
                        responseType: "blob",
                        headers: {
                            Authorization: "Bearer " + this.$store.getters.token,
                        },
                        data: {
                            user_name: this.modalUserName,
                            from_date: this.modalFromDate,
                            to_date: this.modalToDate,
                            rows,
                        },
                    });
                    const dateTime = moment().format("DD-MM-YYYY_HH-mm-ss");
                    const safeName = String(this.modalUserName || "user").replace(/[^\w]+/g, "_");
                    const filePrefix = this.tab === "staff" ? "non_marketing_activity" : "marketing_activity";
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `${filePrefix}_${safeName}_${dateTime}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    console.error("Error downloading the file", error);
                }
            },
            async downloadExcel() {
                try {
                    const payload = this.buildAttendancePayload();
                    const downloadUri = this.tab === "staff"
                        ? "staffAttendance/excelDownloadStaffAttendance"
                        : "attendance/excelDownloadSessionAttendance";
                    const response = await axios({
                        url: this.$store.getters.apiUrl + 'api/' + downloadUri,
                        method: 'POST',
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + this.$store.getters.token,
                        },
                        data: payload,
                    });

                    // Create a link element to download the file
                    const dateTime = moment().format('DD-MM-YYYY_HH-mm-ss');
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const fileName = this.tab === "staff" ? "non_marketing_attendance" : "marketing_attendance";
                    link.setAttribute('download', `${fileName}_${dateTime}.xlsx`); // Set the file name
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    console.error('Error downloading the file', error);
                }
            },
        },
    };
</script>
